export default __webpack_public_path__ + "static/media/handprint-30-31-page.339f9490.png";